module.exports = __webpack_public_path__ + "media/KikiK.9f3d94fb.mp3";